import { createFileRoute } from '@tanstack/react-router';
import { HayvenTapPage } from '@/features/hayven-tap';

export const Route = createFileRoute('/_auth/$orgId/marketing/hayven-tap')({
  component: HayvenTapRoute,
});

function HayvenTapRoute() {
  const { orgId } = Route.useParams();
  return <HayvenTapPage routeOrgId={orgId} />;
}
